/**
 * @deprecated please use @website/ui instead
 */
export * from "./mini-popover";
/**
 * @deprecated please use @website/ui instead
 */
export * from "./mini-popover.types";
